import React, { useState, useEffect } from 'react'
import Api from '../../../../_helpers/Api'
import { trans } from '../../../../_providers/Translation'
import { LineChart } from '@mui/x-charts/LineChart'

const ReservationMetrics = () => {
    const [metrics, setMetrics] = useState(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    useEffect(() => {
        fetchMetrics()
    }, [])

    const fetchMetrics = async () => {
        try {
            setLoading(true)
            console.log('Attempting to fetch reservation metrics...')
            const response = await Api.get('dashboard/reservation-metrics')
            console.log('API Response:', response)
            console.log('API Data:', response.data)
            setMetrics(response.data)
            setError(null)
        } catch (err) {
            console.error('Error fetching reservation metrics:', err)
            console.error('Error details:', {
                message: err.message,
                status: err.response?.status,
                statusText: err.response?.statusText,
                data: err.response?.data
            })

            let errorMessage = 'Failed to load reservation metrics'
            if (err.response?.status === 404) {
                errorMessage = 'API endpoint not found (404). Check if dashboard/reservation-metrics route exists.'
            } else if (err.response?.status === 500) {
                errorMessage = 'Server error (500). Check Laravel logs for details.'
            } else if (err.response?.data?.message) {
                errorMessage = err.response.data.message
            }

            setError(errorMessage)
        } finally {
            setLoading(false)
        }
    }

    const formatPercentage = (percentage) => {
        if (percentage === null || percentage === undefined) return '+0.00%'

        const sign = percentage >= 0 ? '+' : ''
        return `${sign}${percentage.toFixed(2)}%`
    }

    const getPercentageClass = (percentage) => {
        if (percentage === null || percentage === undefined || percentage === 0) return 'neutral'
        return percentage > 0 ? 'positive' : 'negative'
    }

    if (loading) {
        return (
            <div className="reservation-metrics-container">
                <div className="metrics-loading">
                    {trans('buttons.loading')}...
                </div>
            </div>
        )
    }

    if (error || !metrics) {
        return (
            <div className="reservation-metrics-container">
                <div className="metrics-error">
                    {error || 'No metrics data available'}
                </div>
            </div>
        )
    }

    return (
        <>
            <div className="col">
                {/* Open Reservations */}
                <div className="metric-card">
                    <div className='left'>
                        <h4 className="metric-title">Отворени</h4>
                        <span>резервации</span>
                        <b>
                            {metrics.open?.count || 0}
                        </b>
                        <div className={`metric-percentage ${getPercentageClass(metrics.open?.percentage)}`}>
                            {formatPercentage(metrics.open?.percentage)}
                            <span className="percentage-arrow">
                                {metrics.open?.percentage > 0 ? '↗' : metrics.open?.percentage < 0 ? '↘' : '→'}
                            </span>
                        </div>
                    </div>
                    <div className='right'>
                        <LineChart
                            series={[
                                {
                                    curve: "linear",
                                    data: metrics.open?.data,
                                    showMark: false,
                                    disableHighlight: true,
                                    color: metrics.open?.percentage === 0 ? "#6c757d" : metrics.open?.percentage > 0 ? '#28a745' : '#dc3545'
                                },
                            ]}
                            tooltip={{ trigger: 'none' }}
                            axisHighlight={{ x: 'none', y: 'none' }}
                            xAxis={[{ data: [1, 2, 3, 4, 5, 6], disableLine: true, disableTicks: true, hideTooltip: true }]}
                            yAxis={[{ disableLine: true, disableTicks: true, hideTooltip: true }]}
                            slotProps={{
                                legend: { hidden: true }
                            }}
                            margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
                        />
                    </div>
                </div>
            </div>
            <div className="col">
                {/* Closed Reservations */}
                <div className="metric-card">
                    <div className='left'>
                        <h4 className="metric-title">Затворени</h4>
                        <span>резервации</span>
                        <b>
                            {metrics.closed?.count || 0}
                        </b>
                        <div className={`metric-percentage ${getPercentageClass(metrics.closed?.percentage)}`}>
                            {formatPercentage(metrics.closed?.percentage)}
                            <span className="percentage-arrow">
                                {metrics.closed?.percentage > 0 ? '↗' : metrics.closed?.percentage < 0 ? '↘' : '→'}
                            </span>
                        </div>
                    </div>
                    <div className='right'>
                        <LineChart
                            series={[
                                {
                                    curve: "linear",
                                    data: metrics.closed?.data,
                                    showMark: false,
                                    disableHighlight: true,
                                    color: metrics.closed?.percentage === 0 ? "#6c757d" : metrics.closed?.percentage > 0 ? '#28a745' : '#dc3545'
                                },
                            ]}
                            tooltip={{ trigger: 'none' }}
                            axisHighlight={{ x: 'none', y: 'none' }}
                            xAxis={[{ data: [1, 2, 3, 4, 5, 6], disableLine: true, disableTicks: true, hideTooltip: true }]}
                            yAxis={[{ disableLine: true, disableTicks: true, hideTooltip: true }]}
                            slotProps={{
                                legend: { hidden: true }
                            }}
                            margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
                        />
                    </div>
                </div>
            </div>
            <div className="col">
                {/* Initial Status Reservations */}
                <div className="metric-card">
                    <div className='left'>
                        <h4 className="metric-title">Първоначален статус</h4>
                        <span>резервации</span>
                        <b>
                            {metrics.initial_status?.count || 0}
                        </b>
                        <div className={`metric-percentage ${getPercentageClass(metrics.initial_status?.percentage)}`}>
                            {formatPercentage(metrics.initial_status?.percentage)}
                            <span className="percentage-arrow">
                                {metrics.initial_status?.percentage > 0 ? '↗' : metrics.initial_status?.percentage < 0 ? '↘' : '→'}
                            </span>
                        </div>
                    </div>
                    <div className='right'>
                        <LineChart
                            series={[
                                {
                                    curve: "linear",
                                    data: metrics.initial_status?.data,
                                    showMark: false,
                                    disableHighlight: true,
                                    color: metrics.initial_status?.percentage === 0 ? "#6c757d" : metrics.initial_status?.percentage > 0 ? '#28a745' : '#dc3545'
                                },
                            ]}
                            tooltip={{ trigger: 'none' }}
                            axisHighlight={{ x: 'none', y: 'none' }}
                            xAxis={[{ data: [1, 2, 3, 4, 5, 6], disableLine: true, disableTicks: true, hideTooltip: true }]}
                            yAxis={[{ disableLine: true, disableTicks: true, hideTooltip: true }]}
                            slotProps={{
                                legend: { hidden: true }
                            }}
                            margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
                        />
                    </div>
                </div>
            </div>
            <div className="col">
                {/* Final Status Reservations */}
                <div className="metric-card">
                    <div className='left'>
                        <h4 className="metric-title">Краен статус</h4>
                        <span>резервации</span>
                        <b>
                            {metrics.final_status?.count || 0}
                        </b>
                        <div className={`metric-percentage ${getPercentageClass(metrics.final_status?.percentage)}`}>
                            {formatPercentage(metrics.final_status?.percentage)}
                            <span className="percentage-arrow">
                                {metrics.final_status?.percentage > 0 ? '↗' : metrics.final_status?.percentage < 0 ? '↘' : '→'}
                            </span>
                        </div>
                    </div>
                    <div className='right'>
                        <LineChart
                            series={[
                                {
                                    curve: "linear",
                                    data: metrics.final_status?.data,
                                    showMark: false,
                                    disableHighlight: true,
                                    color: metrics.final_status?.percentage === 0 ? "#6c757d" : metrics.final_status?.percentage > 0 ? '#28a745' : '#dc3545'
                                },
                            ]}
                            tooltip={{ trigger: 'none' }}
                            axisHighlight={{ x: 'none', y: 'none' }}
                            xAxis={[{ data: [1, 2, 3, 4, 5, 6], disableLine: true, disableTicks: true, hideTooltip: true }]}
                            yAxis={[{ disableLine: true, disableTicks: true, hideTooltip: true }]}
                            slotProps={{
                                legend: { hidden: true }
                            }}
                            margin={{ top: 0, right: 0, bottom: 0, left: 0 }}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default ReservationMetrics